export const onlyLetters = (text: string) => text.replace(/[^a-zA-Z]+/g, '');
